import Constants from 'constants.js';
import Dispatcher from 'core/Dispatcher';
import UserService from 'services/UserService';
//Facade
import Facade from 'core/Facade';
// Actions
import AlertAction from 'actions/AlertAction';
// Locales
import translate from 'locales/i18n';

class UserAction {
    getUsers() {
        Dispatcher.dispatch({
            actionType: Constants.USERS_GET_START
        });

        UserService.getUsers().then(data => {
            Dispatcher.dispatch({
                actionType: Constants.USERS_GET_END,
                value: Facade.keysToCamel(data)
            });
        }, response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
    }

    addUser(options) {
        UserService.addUser(options).then(data => {
            const newUser = options;
            options.id = data.id;

            Dispatcher.dispatch({
                actionType: Constants.USER_ADDED,
                value: newUser
            });

            AlertAction.open('success', translate.i18n('SUCCESS_ADD_USER'), 'top-right');
        }, err => {
            AlertAction.open('error', translate.i18n('ERROR_ADD_USER'), 'top-right');
            console.log(err);
        });
    }

    updateUser(options, id) {
        UserService.updateUser(options, id).then(() => {
            const updatedUser = options;
            options.id = id;

            Dispatcher.dispatch({
                actionType: Constants.USER_UPDATED,
                value: updatedUser
            });

            AlertAction.open('success', translate.i18n('SUCCESS_UPDATE_USER'), 'top-right');
        }, err => {
            AlertAction.open('error', translate.i18n('ERROR_UPDATE_USER'), 'top-right');
            console.log(err);
        });
    }

    deleteUser(id) {
        UserService.deleteUser(id).then(() => {
            Dispatcher.dispatch({
                actionType: Constants.USER_DELETED,
                value: {
                    id
                }
            });
        }, err => {
            console.log(err);
        });
    }

    // USER ACTIONS
    getUserActions(options) {
        Dispatcher.dispatch({
            actionType: Constants.USER_ACTIONS_GET_START
        });

        UserService.getUserActions(options).then(data => {
            Dispatcher.dispatch({
                actionType: Constants.USER_ACTIONS_GET_END,
                value: Facade.keysToCamel(data)
            });
        }, response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
    }

    getUserActionsGraph(options) {
        Dispatcher.dispatch({
            actionType: Constants.USER_ACTIONS_GRAPH_GET_START
        });

        UserService.getUserActionsGraph(options).then(data => {
            Dispatcher.dispatch({
                actionType: Constants.USER_ACTIONS_GRAPH_GET_END,
                value: Facade.keysToCamel(data)
            });
        }, response => response && response.error && AlertAction.open('error', translate.i18n(response.error), 'top-right'));
    }

    getActionsNames(options) {
        UserService.getActionsNames(options).then(data => {
            Dispatcher.dispatch({
                actionType: Constants.USER_ACTIONS_NAMES_GET,
                value: Facade.keysToCamel(data)
            });
        }, response => response && response.error && AlertAction.open('error', translate(response.error), 'top-right'));
    }
}

export default new UserAction();
